import React, { PureComponent } from 'react'
import { compose, connect } from '@hocs'
import { getPlacePosts } from '@app-core/place/actions'
import PlacePosts from './components/PlacePosts'

class PlacePostsContainer extends PureComponent {
  componentDidUpdate(prevProps) {
    const { placeId: prevPlaceId } = prevProps
    const { placeId } = this.props
    if (prevPlaceId !== placeId) {
      this._getPlacePosts()
    }
  }

  _getPlacePosts = () => {
    const { hasMorePosts, userId, placeId, page, score, sort, isPostsLoading } = this.props
    if (hasMorePosts && !isPostsLoading) {
      this.props.getPlacePosts({ userId, placeId, page, score, sort })
    }
  }

  render() {
    const { displayPostIds, hasMorePosts, isPostsLoading, displayCommentIds } = this.props
    return (
      <PlacePosts
        key={`PlacePostsContainer-${displayPostIds.size}-${displayCommentIds.size}`}
        displayPostIds={displayPostIds}
        displayCommentIds={displayCommentIds}
        isPostsLoading={isPostsLoading}
        hasMorePosts={hasMorePosts}
        getPlacePosts={this._getPlacePosts}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.currentUser.getIn(['userInfo', 'uid']),
    displayPostIds: state.place.get('displayPostIds'),
    hasMorePosts: state.place.get('hasMorePosts'),
    isPostsLoading: state.place.get('isPostsLoading'),
    page: state.place.get('nextPostsPage'),
    score: state.place.get('nextPostsScore'),
    sort: state.place.get('postsSortingMethod'),
    displayCommentIds: state.place.get('displayCommentIds'),
  }
}

export default compose(connect(mapStateToProps, { getPlacePosts }))(PlacePostsContainer)
